import { BoxSection } from 'app/components';
import { UsersAccessListContent } from '../UsersAccessListContent';
import PanelTitle from 'app/components/typography/heading/PanelTitle/PanelTitle';

const UsersAccessPageContent = () => {
  return (
    <>
      <PanelTitle>Gestão de Acessos</PanelTitle>
      <BoxSection>
        <UsersAccessListContent />
      </BoxSection>
    </>
  );
};

export default UsersAccessPageContent;
